import React from "react";

const Advertisements = () => {
  return <div>advertisements</div>;
};

export default Advertisements;
